module.exports = __webpack_public_path__ + "static/media/attachment-icon.5f650d79.svg";